var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthLayout',[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"text-h1 font-weight-medium"},[_vm._v("404")]),_c('div',{staticClass:"text-h2"},[_vm._v(_vm._s(_vm.$t("error.pageNotFound")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }